module.exports = __webpack_public_path__ + "img/8.f6c1dfda.jpg";